module.exports = __webpack_public_path__ + "img/company.6dd1836a.svg";